import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/pro-solid-svg-icons/faXmark';
import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import classnames from 'clsx';

import { NotificationService, NOTIFICATION_TYPES, NOTIFICATION_TYPE_INFO } from '../../services/notification-service';

import style from './notification.module.less';
import { noop } from 'ui-components/default-props/noop';

const dismissNotification = (id) => {
  NotificationService.removeNotification(id);
};

export const NotificationCloseButton = ({
  hideCloseButton = false,
  notificationType = NOTIFICATION_TYPE_INFO,
  id,
  onClose = noop,
  trackNotificationClose = noop,
  withMobileStyling = false,
}) => {
  const dismissAndTriggerCloseEvents = useCallback(() => {
    trackNotificationClose();
    dismissNotification(id);
    onClose(id);
  }, [id, onClose, trackNotificationClose]);
  if (hideCloseButton) {
    return null;
  }

  return (
    <button
      className={classnames('unstyled-button', style['close-button'], style[`theme-${notificationType}`], {
        [style.mobile]: withMobileStyling,
      })}
      onClick={dismissAndTriggerCloseEvents}
    >
      <FontAwesomeIcon icon={faXmark} />
    </button>
  );
};

NotificationCloseButton.propTypes = {
  notificationType: PropTypes.oneOf(NOTIFICATION_TYPES),
  hideCloseButton: PropTypes.bool,
  id: PropTypes.string.isRequired,
  onClose: PropTypes.func,
  trackNotificationClose: PropTypes.func,
  withMobileStyling: PropTypes.bool,
};
